Vue.use(VueDataScooper);
new Vue({
    el: "#fSignIn",
    data: {
        loading: false,
        user: {
            login: null,
            password: null
        },
        errors: {},
        error: null,
    },
    methods: {
        doLogin: function () {
            let ctx = this;
            this.loading = true;
            this.$http.post('/api/login', this.user)
                .then(response => {
                    console.log('response',response);
                    let body = response.body;
                    if (body.hasOwnProperty("done")) {
                        if (body.done) {
                            window.location.href = body.path;
                            setTimeout(() => {
                                toast.show('Вы успешно авторизовались. Пожалуйста, подождите! Происходит переход в личный кабинет.', 60000);
                            }, 300);
                            this.loading = false;
                        }
                    }
                })
                .catch(App.handlers.httpError(() => { ctx.loading = false;   }));
        }
    }
});

window.App = App;